import { useMediaQuery, useTheme } from '@material-ui/core'
import PageMetaData from '@v4/utils/data/PageMetaData'
import useStyles from './Content.styled'

export const useContent = props => {
	const {
		direction,
		desktopImage,
		mobileImage,
		mobileDirection,

		title,
		titleConfig,
		text,
		textConfig,
		onTitleClick,
		onTextClick,
		extraShortcuts,
		textEditable,
		titleEditable,
		onTextChange,
		onTitleChange,
		textKey,
		titleKey,
	} = props

	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'))

	const isMobileImage = isMobile && !!mobileImage?.image

	const image = isMobileImage ? mobileImage : desktopImage

	const isImageExist = !!image?.image

	const isBackground = mobileDirection === PageMetaData.IMAGE_POSITION.BACKGROUND

	const classes = useStyles(props)

	return [
		{
			classes,
			direction: isMobile ? null : PageMetaData.CONTENT_DIRECTION[direction],
			mobileDirection: isMobile ? PageMetaData.CONTENT_DIRECTION[mobileDirection] : null,
			extraShortcuts,
			withBgImage: isMobile ? isBackground && isImageExist : null,
			withImage: isMobile ? !isBackground && isImageExist : isImageExist,
			image,
			isMobile,

			title,
			titleKey,
			titleConfig,
			titleEditable,

			text,
			textKey,
			textConfig,
			textEditable,
		},
		{
			handleTitleClick: onTitleClick,
			handleTextClick: onTextClick,
			handleTextChange: onTextChange,
			handleTitleChange: onTitleChange,
		},
	]
}
